// extracted by mini-css-extract-plugin
export var accent = "_bg-4";
export var add = "_bg-j";
export var addIcon = "_bg-k";
export var deleteIcon = "_bg-i";
export var disabled = "_bg-9";
export var ellipsis = "_bg-f";
export var error = "_bg-3";
export var form = "_bg-5";
export var hideFocus = "_bg-2";
export var icon = "_bg-7";
export var input = "_bg-e";
export var listItem = "_bg-h";
export var mediumHeight = "_bg-b";
export var noBorder = "_bg-8";
export var noRadius = "_bg-1";
export var shortHeight = "_bg-a";
export var tallHeight = "_bg-c";
export var textInput = "_bg-0";
export var vertical = "_bg-g";
export var veryTallHeight = "_bg-d";
export var widget = "_bg-6";